import React, { Fragment } from "react";
import PropTypes from "prop-types";

class ActiveSelect extends React.Component {
  state = {
    userStatus: true
  };

  onChange = e => {
    this.setState({ userStatus: e.target.value });
    setTimeout(
      function() {
        this.props.newActiveCallback(this.state.userStatus);
      }.bind(this),
      300
    );
  };

  options_with_tally = (tally) => {
    return (
      <Fragment>
        <option value={null}>All Employees ({tally.total})</option>
        <option value={true}>Active Employees {`(${tally.active}/${tally.limit})`}</option>
        <option value={false}>Inactive Employees ({tally.inactive})</option>
      </Fragment>
    )
  }

  options = () => {
    if (this.props.userTally) {
      return this.options_with_tally(this.props.userTally)
    } else {
      return (
        <Fragment>
          <option value={null}>All Employees</option>
          <option value={true}>Active Employees</option>
          <option value={false}>Inactive Employees</option>
        </Fragment>
      )
    }
  }

  render() {
    return (
      <div className="col-md-3 col-xs-12">
        <select
          className="form-control"
          title='Active Employees'
          value={this.state.userStatus}
          onChange={e => this.onChange(e)}
        >
          {this.options()}
          {this.props.children ? this.props.children : null}
        </select>
      </div>
    );
  }
}

ActiveSelect.propTypes = {
  newActiveCallback: PropTypes.func,
  userTally: PropTypes.object
};

export default ActiveSelect;
